// extracted by mini-css-extract-plugin
module.exports = {"root":"TheoryTestPage_root__tLRNw","subtitle":"TheoryTestPage_subtitle__DDvjW","text":"TheoryTestPage_text__2qz3U","links":"TheoryTestPage_links__JJdvD"};